module.exports = __webpack_public_path__ + "static/media/VID_20160615_091654.ba8c0619.mp4";